import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.tsx';
import LoadingSpinner from './LoadingSpinner.js';
import './Login.css';

const Login = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');
  
  const { login, currentUser, loading, error: authError, clearError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/home";

  useEffect(() => {
    // If user is already logged in, redirect them
    if (!loading && currentUser) {
      navigate(from, { replace: true });
    }
    // Clear previous errors
    if (clearError) {
        clearError();
    }
  }, [currentUser, loading, navigate, from, clearError]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLocalError('');
    if (clearError) clearError();

    try {
      await login(identifier, password);
      // On success, the useEffect hook will handle the redirect.
    } catch (err) {
      let errorMessage = 'An unknown error occurred.';
      if (err.message) {
        errorMessage = err.message;
      }
      setLocalError(errorMessage);
    }
  };
  
  // Show loading spinner if auth is in progress
  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="login-container">
      <Helmet>
        <title>Login - School Portal</title>
      </Helmet>
      
      <div className="login-card">
        <div className="login-content">
          <div className="login-header">
            <h2>Welcome Back!</h2>
            <p>Please sign in to continue.</p>
          </div>

          {(localError || authError) && (
            <div className="alert alert-danger">
              {localError || authError}
            </div>
          )}
          
          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="identifier">Email or Username</label>
              <input
                id="identifier"
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="form-options">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
            <button type="submit" className="login-btn" disabled={loading || !identifier || !password}>
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>
          <div className="login-footer">
            <p>Don't have an account? <Link to="/signup">Sign Up</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;